function formatComponentName (vm) {
  if (vm.$root === vm) {
    return 'root instance';
  }
  /* eslint-disable */
  const name = vm._isVue ? vm.$options.name || vm.$options._componentTag : vm.name;
  return (
    (name ? 'component <' + name + '>' : 'anonymous component') +
    (vm._isVue && vm.$options.__file ? ' at ' + vm.$options.__file : '')
  );
};

export const vueErrorHandel = (error, vm, info) => {
  const metaData = {};
  // vm and lifecycleHook are not always available
  if (Object.prototype.toString.call(vm) === '[object Object]') {
    metaData.componentName = formatComponentName(vm);
    metaData.propsData = vm.$options && vm.$options.propsData;
  }
  if (info && typeof info !== 'undefined') {
    metaData.lifecycleHook = info;
  }
  if (window.Owl) {
    window.Owl.addError(error, {
      tags: metaData,   //tags<Object> 自定义错误信息
    });
  }
  console.error(error);
};




// WEBPACK FOOTER //
// ./src/components/util/vueErrorHandel.js